import { Injectable } from '@angular/core';
import * as notificationActions from './notification.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  map,
  switchMap
} from 'rxjs/operators';
import { NotificationService } from './notification.service';
import { of } from 'rxjs';

@Injectable()
export class NotificationEffects {
  loadNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationActions.loadNotifications),
      switchMap((action) =>
        this.notificationService
          .getNotifications(action.prfyear, action.groupcode)
          .pipe(
            map((data) =>
              notificationActions.loadNotificationsSuccess({
                items: data.items,
              })
            ),
            catchError((error) =>
              of(notificationActions.reset())
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService
  ) {}
}
